import request from '@/utils/request'
// 获取小说列表
export function getList(params) {
  return request({
    url: '/novel_management/novels',
    method: 'get',
    params
  })
}

// 获取小说列表
export function addNovalList(data) {
  return request({
    url: '/novel_management/novels',
    method: 'post',
    data
  })
}

// 小说废弃
export function novelAbandonment(data) {
  return request({
    url: `/novel_management/novel/discard`,
    method: 'post',
    data
  })
}

// 小说筛选列表
export function novelScreening(params = {}) {
  return request({
    url: `/common/novel_list`,
    method: 'get',
    params
  })
}

// 平台筛选列表
export function platformFiltering(params = {}) {
  return request({
    url: `/common/platform_list`,
    method: 'get',
    params
  })
}

// 小说废弃信息
export function novelAbandoned(params = {}) {
  return request({
    url: `/novel_management/novel/discard_info`,
    method: 'get',
    params
  })
}

